import React from 'react';
import { Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import Text from '../../../../components/Text';
import styled from 'styled-components';

interface AutoRenewSwitchProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
}

const AutoRenewSwitch = ({ value, onChange }: AutoRenewSwitchProps) => {
  return (
    <Container>
      <Switch
        checked={value}
        onChange={onChange}
        checkedChildren={<CheckOutlined />}
        unCheckedChildren={<CloseOutlined />}
      />

      <Text variant='H9' ml={1}>
        Auto Renew
      </Text>
    </Container>
  );
};

export default AutoRenewSwitch;

const Container = styled.div`
  display: flex;
  align-items: center;
`;
